export const isWebView = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /\bwv\b/i.test(ua) ||
    /WebView/i.test(ua) ||
    /; wv\)/i.test(ua) ||
    (/Android/i.test(ua) && /Version\/[\d.]+/i.test(ua) && /Chrome/i.test(ua))
  );
};

export const isTouchDevice = () => {
  if (typeof window === 'undefined') return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const isCompactComposeView = () => {
  if (typeof window === 'undefined') return false;
  const width = window.innerWidth;
  if (width <= 768) return true;
  if (isWebView()) return true;
  if (isTouchDevice() && width <= 1024) return true;
  return false;
};
